import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=364636fe&scoped=true&"
import script from "./Sorter.vue?vue&type=script&lang=babel&"
export * from "./Sorter.vue?vue&type=script&lang=babel&"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=364636fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364636fe",
  null
  
)

export default component.exports